import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class CalendarEventsDataProvider {
	CALENDAR_EVENTS_URL = '/protected/rest/calendar/event';

	constructor(public http: HttpClient, private datePipe: DatePipe) {}

	createEvent(appointment) {
		const url = `${this.CALENDAR_EVENTS_URL}/new`;
		return this.http.post(url, appointment);
	}

	updateEvent(appointment) {
		const url = `${this.CALENDAR_EVENTS_URL}/update`;
		return this.http.post(url, appointment);
	}

	deleteEvent(eventId) {
		const url = `${this.CALENDAR_EVENTS_URL}/delete?id=${eventId}`;
		return this.http.post(url, null);
	}

	getEventsForPage(start, end, format: string) {
		const url = '/protected/rest/calendar/events';
		let params: HttpParams = new HttpParams();
		params = params.append('start', this.datePipe.transform(start, format));
		params = params.append('end', this.datePipe.transform(end, format));

		return this.http.get(url, { params });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/calendar/calendar-events.data.service.ts